import React from 'react';

import {
  Dropdown,
  LabelIcon,
  StyledTextField,
  Wrapper
} from './styles';

const FilterContainer = ({
  isOpen,
  label,
  children,
  alignDropdownRight,
  value,
  onClick,
}) => {

  return (
  <Wrapper isOpen={isOpen} className='filter-container'>
    <StyledTextField
      size='small'
      label={label}
      onClick={onClick}
      fullWidth
      focused={false}
      value={value || ''}
      InputProps={{
        readOnly: true,
      }}
    />
    <LabelIcon isOpen={isOpen} onClick={onClick} name="arrow_drop_down" />
    <Dropdown isOpen={isOpen} alignDropdownRight={alignDropdownRight}>
      {isOpen && children}
    </Dropdown>
  </Wrapper>
)};

export default FilterContainer;
